var React = require('react');

function ChevronInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10.9997 1.55551L5.9997 5.99996L0.999702 1.55551","strokeWidth":"2","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"}));
}

ChevronInline.defaultProps = {"width":".75em","height":".5em","viewBox":"0 0 12 8","fill":"none","stroke":"currentColor"};

module.exports = ChevronInline;

ChevronInline.default = ChevronInline;
